function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".discA,.discB{fill:none;stroke:coral;stroke-linejoin:round;stroke-width:2px;}.discB{stroke-linecap:round;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-336.5 -611)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(356.475 630.975)"
}, /*#__PURE__*/React.createElement("path", {
  className: "discA",
  d: "M362.177,630.839A5.838,5.838,0,1,1,356.34,625,5.839,5.839,0,0,1,362.177,630.839Z",
  transform: "translate(-350.5 -625)"
}), /*#__PURE__*/React.createElement("line", {
  className: "discB",
  x2: 4.63,
  y2: 4.63,
  transform: "translate(9.966 9.966)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(337.5 612)"
}, /*#__PURE__*/React.createElement("path", {
  className: "discB",
  d: "M354.286,645.571a16.786,16.786,0,1,1,16.786-16.786",
  transform: "translate(-337.5 -612)"
}), /*#__PURE__*/React.createElement("path", {
  className: "discB",
  d: "M348.8,636.584v-3.649l-7.3-5.839,3.287-5.109h8.39v-4.379l-2.189-1.46,6.369-3.649",
  transform: "translate(-335.662 -611.77)"
}), /*#__PURE__*/React.createElement("path", {
  className: "discB",
  d: "M359.912,615.755l-2.551,4.737h-2.554l-2.554,2.554",
  transform: "translate(-330.72 -610.274)"
})));

function SvgDiscover(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.986,
    height: 35.986,
    viewBox: "0 0 35.986 35.986",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscover);
export default __webpack_public_path__ + "static/media/Discover.7e82cde6.svg";
export { ForwardRef as ReactComponent };